import { Collapse, type CollapseProps } from "@mui/material"
import { type PropsWithChildren, useContext } from "react"
import { CollapsibleCtx } from "./collapsibleContext"

export const CollapsibleBlock = ({
  children,
  ...collapseProps
}: PropsWithChildren<Omit<CollapseProps, "in">>) => {
  const { expanded } = useContext(CollapsibleCtx)

  return (
    <Collapse in={expanded} {...collapseProps}>
      {children}
    </Collapse>
  )
}
